import { FC, PropsWithChildren, useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ScrollingContextProvider, useScrollingContext } from './context';
import { IRegisterSectionOptions, IScrollingContext } from './types';

export const WithNavigationContext: FC<PropsWithChildren> = ({ children }) => {
  const [sections, setSections] = useState<IScrollingContext['sections']>([]);
  const { i18n} = useTranslation()

  const registerSection: IScrollingContext['registerSection'] = useCallback((options) => {
    setSections((prevState) => {
      return prevState
        .concat(options)
        .sort((a, b) => a.index - b.index)
        .filter((item, index, self) => index === self.findIndex((t) => t.hash === item.hash));
    });
  }, []);

  const ctx = useMemo<IScrollingContext>(() => ({ sections, registerSection }), [sections, registerSection, i18n.language]);

  return <ScrollingContextProvider value={ctx}>{children}</ScrollingContextProvider>;
};

export const useRegisterSection = (options: IRegisterSectionOptions) => {
  const { registerSection } = useScrollingContext();
  const { i18n} = useTranslation()

  const ref = useCallback(() => {
    registerSection(options);
  }, [registerSection, options, i18n.language]);

  return {
    ref,
    id: options.hash,
  };
};
